var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 54,
    viewBox: "0 0 51 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.625 22.5C44.625 38.25 25.5 51.75 25.5 51.75C25.5 51.75 6.375 38.25 6.375 22.5C6.375 17.1294 8.38995 11.9787 11.9766 8.18109C15.5632 4.38348 20.4277 2.25 25.5 2.25C30.5723 2.25 35.4368 4.38348 39.0234 8.18109C42.6101 11.9787 44.625 17.1294 44.625 22.5Z",
    fill: "#0B8E70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 29.25C29.0208 29.25 31.875 26.2279 31.875 22.5C31.875 18.7721 29.0208 15.75 25.5 15.75C21.9792 15.75 19.125 18.7721 19.125 22.5C19.125 26.2279 21.9792 29.25 25.5 29.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinDark);
export default __webpack_public_path__ + "static/media/map-pinDark.7a6b73c9422cd9338fa0f466e830c844.svg";
export { ForwardRef as ReactComponent };